export default __webpack_public_path__ + "static/media/Arm-straps of Crimson Slaughter (nm).41abdac4.jpg";